import { render } from "./AlarmcodesGeneral.vue?vue&type=template&id=423faf98"
import script from "./AlarmcodesGeneral.vue?vue&type=script&lang=js"
export * from "./AlarmcodesGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__